import LumpsumIndex from "@/components/lumpsum/Lumpsum.vue";
import ListLumpsum from "@/components/lumpsum/ListLumpsum.vue";


let routesLumpsum= [
    {
        path: '',
        meta: {
          title: "Chain System",
        },
        name: "LumpsumIndex",
        component: LumpsumIndex
    },

    {
      path: 'detail/:id',
      meta: {
        title: "Chain System",
      },
      name: "ListLumpsum",
      component: ListLumpsum
  },
      
]

export default routesLumpsum
  